import { authHeaders } from './authService';

export async function getAvailableDrivers() {
  const res = await fetch('/api/sharing/drivers', { headers: authHeaders() });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to load drivers');
  return data.users;
}

export async function sendRequest(toUid) {
  const res = await fetch('/api/sharing/requests', {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ toUid }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to send request');
  return data.request;
}

export async function getRequests() {
  const res = await fetch('/api/sharing/requests', { headers: authHeaders() });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to load requests');
  return data;
}

export async function acceptRequest(requestId) {
  const res = await fetch(`/api/sharing/requests/${requestId}/accept`, {
    method: 'POST',
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to accept request');
  return data.connection;
}

export async function declineRequest(requestId) {
  const res = await fetch(`/api/sharing/requests/${requestId}/decline`, {
    method: 'POST',
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to decline request');
}

export async function cancelRequest(requestId) {
  const res = await fetch(`/api/sharing/requests/${requestId}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to cancel request');
}

export async function getConnections() {
  const res = await fetch('/api/sharing/connections', { headers: authHeaders() });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to load connections');
  return data.connections;
}

export async function removeConnection(targetUid) {
  const res = await fetch(`/api/sharing/connections/${targetUid}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to remove connection');
}

export async function getSharedSessions(trackId) {
  const params = trackId ? `?trackId=${encodeURIComponent(trackId)}` : '';
  const res = await fetch(`/api/sharing/sessions${params}`, { headers: authHeaders() });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to load shared sessions');
  return data.users;
}

export async function getSharedSessionData(uid, fileName) {
  const res = await fetch(`/api/sharing/session/${uid}/${fileName}`, { headers: authHeaders() });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to load shared session');
  }
  return res.json();
}

export async function getAvailability() {
  const res = await fetch('/api/sharing/availability', { headers: authHeaders() });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to load availability');
  return data.available;
}

export async function setAvailability(available) {
  const res = await fetch('/api/sharing/availability', {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify({ available }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to update availability');
  return data.available;
}
